export default {
    userName: (state) => state.userName,
  };
  